import { Directive, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MmaoPopinComponent } from '@app/shared/components/mmao/mmao-popin/mmao-popin.component';
import { Product, Negotiation } from '@vestiaire/api-sdk-angular';
import { IsLoggedGuard } from '@app/shared/guards';

@Directive({
  selector: '[appOpenMmaoPopin]'
})
export class OpenMmaoPopinDirective {
  @Input()
  product: Product;
  @Input()
  negotiation: Negotiation | null;
  @Input()
  buyerId: string;
  @Input()
  commentId: string | null;

  constructor(public modal: MatDialog, public loggedGuard: IsLoggedGuard) {}

  @HostListener('click', ['$event'])
  openPopinAlert() {
    if (this.loggedGuard.isLoggedIn()) {
      this.modal.open(MmaoPopinComponent, {
        disableClose: false,
        maxWidth: 600,
        minHeight: 400,
        data: {
          product: this.product,
          buyerId: this.buyerId,
          negotiation: this.negotiation,
          commentId: this.commentId
        }
      });
    }
  }
}
